import configAxios from "./axiosConfig";

export const patch = async ({ path, data, token, headers }) => {
  const response = await configAxios.patch(path, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...headers,
    },
  });

  return response.data;
};
